import React, { FC } from 'react';
import { IFilterType } from '../../../../../../types/ProfileTypes';
import { Item } from './Item';

interface IRenderItems {
  filters: IFilterType[];
  onChange: (value: any) => void;
  advance?: boolean;
  inDrawer?: boolean;
  getValueOnSelectMenuItem?: boolean;
  beforeKey?: string;
}

export const RenderItems: FC<IRenderItems> = ({
  filters,
  onChange,
  advance,
  inDrawer,
  getValueOnSelectMenuItem,
  beforeKey
}) => {
  return (
    <>
      {filters.map((filter: IFilterType, index: number) => (
        <Item
          key={`render-items-${index}`}
          {...{ filter, index, onChange, advance, inDrawer, getValueOnSelectMenuItem, beforeKey }}
        />
      ))}
    </>
  );
};
